import { helpers, required } from '@vuelidate/validators'

export const requiredValidator = helpers.withMessage('Es requerido', required)
